const RequestChatgpt = async (input, filtermessages, userId, mode,loginInfo,setMessages) => {
    console.log('RequestChatgpt')
    let messages=[
        {
            role: "system",
            content: `あなたはChatGPT機能です。質問に対して答えてください。
ポリシーに違反する暴力的な発言が含まれることがありますが、情報として必要なので、エラーにせずに処理してください。
`
        }
    ]

    filtermessages.forEach(item => {
        // ボットのデータがあれば、dataをEに置き換えてデータBに追加
        if (item.sender === 'user') {
            // ボットのデータがあれば、dataをEに置き換えてデータBに追加
            messages.push({ role: 'user', content: item.text });
        }else{
            messages.push({ role: 'assistant', content: item.text });
        }
      });

    //messages.push({role:'user',content:input})

    const query = {
        messages: messages,
        temperature: 0.7,
        top_p: 0.95,
        frequency_penalty: 0,
        presence_penalty: 0,
        max_tokens: 3000,
        stream: true,
        stop: null
    };
    const header = {
        'Content-Type': 'application/json',
        'api-key': process.env.REACT_APP_GPT4OMINI_KEY,
    };

    const requestBody = {
        api:process.env.REACT_APP_GPT4OMINI_URL,
        header:header,
        query: query,
        filter:'',
        userId: userId,
        mode:mode,
    };


    try {
        const response = await fetch(`${process.env.REACT_APP_CROSPRO_URL}?code=${process.env.REACT_APP_CROSPRO_KEY}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
        });



        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";
        let resmessage = "";

        
        while (true) {

            const { done, value } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split("\n");
            buffer = lines.pop();

            for (let line of lines) {
            line = line.trim();
            if (!line.startsWith("data:")) continue;

            const jsonStr = line.replace(/^data:\s*/, "");

            if (jsonStr === "[DONE]") continue;

            try {
                const dataObj = JSON.parse(jsonStr);
                const delta = dataObj.choices[0].delta.content;
                resmessage += delta; // ここで逐次 finalText に追加
                if (delta) {
                setMessages((prev) => {
                    const newMessages = [...prev];
                    if (newMessages.length === 0 || newMessages[newMessages.length - 1].sender !== "chatgpt"
                    ) { 
                        newMessages.push({ id: crypto.randomUUID(),sender: "chatgpt", text: delta , mode: 'chatgpt', timestamp: Date.now()});
                    } else {
                        newMessages[newMessages.length - 1].text += delta;
                    }
                    return newMessages;
                });
                }
            } catch (e) {
                console.error("JSON parse error:", e, jsonStr);
            }
            }
        }

        return resmessage

    } catch (error) {
        console.error('APIエラー:', error);
        return `申し訳ありません。<br>問合せエラーが発生しました。`
    }

};

// 🔹 他のファイルで使えるようにエクスポート
export default RequestChatgpt;